<div class="charge-items" [ngClass]="direction">
  <ng-container *ngIf="isExternalBooking || !inquiry?.bookingEngine">
    <div class="charge-item">
      <div class="label" i18n>Base Charge</div>
      <div class="value">
        <span [innerHtml]="charges?.charge | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Additional Guests Fee</div>
      <div class="value">
        <span [innerHtml]="charges?.extraGuests | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Discounts & Fees</div>
      <div class="value">
        <span [innerHtml]="(charges?.discountSum || 0) + (charges?.feeSum || 0) | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Taxes</div>
      <div class="value">
        <span [innerHtml]="charges?.taxFee || 0 | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div *ngIf="!!formulaAdjustedCost" class="charge-item">
      <div class="label">
        <span [matTooltip]="getBookingFormulaTooltip()" matTooltipPosition="above" i18n> Booking Formula </span>
      </div>
      <div class="value">
        <span class="formula-cost" [innerHtml]="formulaAdjustedCost | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div *ngIf="status" class="charge-item">
      <div class="label">
        <span [matTooltip]="getRemainingTooltip()" matTooltipPosition="above"
          ><ng-container i18n>Total</ng-container> (<span
            >{{ getStatusTooltip | call : status.status }} <i class="fal fa-money-bill-alt"></i></span
          >)</span
        >
        <a
          *ngIf="hasChannelPrice"
          i18n-matTooltip
          matTooltip="View booking breakdown"
          (click)="onChannelBreakdown()"
          class="ml-2"
        >
          <i class="far fa-server"></i>
        </a>
      </div>
      <div class="value">
        <span
          class="total-price"
          [matTooltip]="currencyCode"
          matTooltipPosition="right"
          [ngClass]="{ 'text-success': status.paid, 'text-danger': !status.paid }"
          [innerHtml]="charges?.sum || 0 | tokeetCurrency : currency"
        ></span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isExternalBooking && !!inquiry?.bookingEngine">
    <div class="charge-item">
      <div class="label" i18n>Base Charge</div>
      <div class="value">
        <span [innerHtml]="inquiry?.bookingEngine?.extraBedroomsBase | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Additional Guests Fee</div>
      <div class="value">
        <span [innerHtml]="inquiry?.bookingEngine?.extraGuests | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item" *ngIf="!!inquiry?.bookingEngine?.extraBedrooms">
      <div class="label" i18n>Additional Bedrooms Fee</div>
      <div class="value">
        <span [innerHtml]="inquiry?.bookingEngine?.extraBedrooms | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Discounts & Fees</div>
      <div class="value">
        <span [innerHtml]="inquiry?.bookingEngine?.discountTotal | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div *ngFor="let fee of inquiry?.bookingEngine?.bookingFees" class="charge-item">
      <div class="label">
        {{ getFeeName(fee.name) }}
      </div>
      <div class="value">
        <span [innerHtml]="fee.amount | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div class="charge-item">
      <div class="label" i18n>Taxes</div>
      <div class="value">
        <span [innerHtml]="inquiry?.bookingEngine?.taxTotal | tokeetCurrency : currency"></span>
      </div>
    </div>
    <div *ngIf="status" class="charge-item total">
      <div class="label">
        <span [matTooltip]="getRemainingTooltip()" matTooltipPosition="above"
          ><ng-container i18n>Total</ng-container> (<span
            >{{ getStatusTooltip | call : status.status }} <i class="fal fa-money-bill-alt"></i></span
          >)</span
        >
      </div>
      <div class="value">
        <span
          class="total-price"
          [matTooltip]="currencyCode"
          matTooltipPosition="right"
          [ngClass]="{ 'text-success': status.paid, 'text-danger': !status.paid }"
          [innerHtml]="inquiry?.bookingEngine?.total | tokeetCurrency : currency"
        ></span>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!(1 | isReadonlyRole)" class="d-flex flex-column gap-3">
    <!-- Edit -->
    <ng-container *ngIf="!readonly">
      <a
        i18n-matTooltip
        matTooltip="Edit booking charges"
        matTooltipPosition="above"
        (click)="onUpdateQuote()"
        class="btn btn-secondary-light"
      >
        <i class="cs-icon cs-icon-pencil"></i>
      </a>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="applicableFees && applicableFees$ | async as fees">
  <div i18n class="w-100 text-light mt-3" *ngIf="fees.length" [class.text-right]="direction === 'h'">
    These booking fees may apply:
  </div>
  <div class="charge-items" *ngIf="fees.length" [ngClass]="direction">
    <div class="charge-item" *ngFor="let fee of fees">
      <div class="label">{{ getFeeName(fee.name) }}</div>
      <div class="value">
        <span
          [innerHtml]="
            fee.type === feeTypes.Percent
              ? fee.amount + '%'
              : (fee.amount | tokeetCurrency : currency) + ' / ' + feeModalityLabels[fee.modality]
          "
        ></span>
      </div>
    </div>
  </div>
</ng-container>
